import { render, staticRenderFns } from "./applicantTypeContainer.vue?vue&type=template&id=046dd6d2&scoped=true"
import script from "./applicantTypeContainer.vue?vue&type=script&lang=js"
export * from "./applicantTypeContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046dd6d2",
  null
  
)

export default component.exports